/* Tail & Bark theme JS — header, mobile nav, AJAX cart drawer, PDP.
 * No dependencies. Talks to Shopify's AJAX Cart API (/cart/*.js). */
(function () {
  "use strict";

  var S = window.themeStrings || {};
  var SETTINGS = window.themeSettings || {};

  /* Liquid HTML-escapes translation output, so "we'll" reaches us as
     "we&#39;ll". Left alone that surfaces two ways: esc() escapes the
     ampersand again and the page shows a literal &#39;, and textContent
     assignments print the entity verbatim. Decode once, here, so every
     consumer below works with the real character. */
  (function decodeThemeStrings() {
    var ta = document.createElement("textarea");
    Object.keys(S).forEach(function (k) {
      if (typeof S[k] === "string" && S[k].indexOf("&") !== -1) {
        ta.innerHTML = S[k];
        S[k] = ta.value;
      }
    });
  })();
  var ROUTES = window.routes || { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cartGet: "/cart.js", cart: "/cart" };

  /* ── money ─────────────────────────────────────────── */
  var moneyFmt = new Intl.NumberFormat(document.documentElement.lang || "en", {
    style: "currency",
    currency: window.cartCurrency || "EUR",
  });
  function money(cents) {
    return moneyFmt.format((cents || 0) / 100);
  }

  /* ── header scroll state ───────────────────────────── */
  var hdr = document.getElementById("hdr");
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle("scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ── mobile nav ────────────────────────────────────── */
  var mobNav = document.getElementById("mob-nav");
  function setMobNav(open) {
    if (!mobNav) return;
    mobNav.classList.toggle("open", open);
    /* aria-hidden takes the panel out of the accessibility tree but leaves
       its links in the tab order, so a closed drawer could still be tabbed
       into — which is what Lighthouse flags as "[aria-hidden] elements
       contain focusable descendents". inert removes both. */
    mobNav.setAttribute("aria-hidden", String(!open));
    mobNav.toggleAttribute("inert", !open);
  }
  var openMenu = document.getElementById("open-menu");
  var closeMenu = document.getElementById("close-menu");
  if (openMenu) openMenu.addEventListener("click", function () { setMobNav(true); });
  if (closeMenu) closeMenu.addEventListener("click", function () { setMobNav(false); });
  if (mobNav) mobNav.addEventListener("click", function (e) {
    if (e.target.closest("a")) setMobNav(false);
  });

  /* ── locale switcher pill ──────────────────────────── */
  var lang = document.getElementById("tb-lang");
  if (lang) {
    var langBtn = lang.querySelector(".tb-lang-btn");
    langBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = lang.classList.toggle("open");
      langBtn.setAttribute("aria-expanded", String(open));
    });
    document.addEventListener("click", function () {
      lang.classList.remove("open");
      langBtn.setAttribute("aria-expanded", "false");
    });
  }

  /* ── cart drawer ───────────────────────────────────── */
  var drawer = document.getElementById("cart");
  var scrim = document.getElementById("scrim");
  var body = document.getElementById("cart-body");
  var foot = document.getElementById("cart-foot");

  function setCartOpen(open) {
    if (!drawer || !scrim) return;
    drawer.classList.toggle("open", open);
    scrim.classList.toggle("open", open);
    drawer.setAttribute("aria-hidden", String(!open));
    drawer.toggleAttribute("inert", !open);
    document.body.style.overflow = open ? "hidden" : "";
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { setCartOpen(false); setMobNav(false); }
  });
  if (scrim) scrim.addEventListener("click", function () { setCartOpen(false); });
  var closeCartBtn = document.getElementById("close-cart");
  if (closeCartBtn) closeCartBtn.addEventListener("click", function () { setCartOpen(false); });
  var openCartBtn = document.getElementById("open-cart");
  if (openCartBtn) openCartBtn.addEventListener("click", function () {
    refreshCart().then(function () { setCartOpen(true); });
  });

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Dog name — shared by the PDP required field and the cart drawer's
     inline capture. English letters, space/hyphen/apostrophe inside, 1–14 chars. */
  var NAME_RE = /^[A-Za-z](?:[A-Za-z' -]*[A-Za-z])?$/;
  function nameValidate(raw) {
    var value = String(raw || "").trim().replace(/\s+/g, " ");
    if (!value) return { ok: false, msg: S.dogNameEmpty };
    if (value.length > 14) return { ok: false, msg: S.dogNameTooLong };
    if (!NAME_RE.test(value)) return { ok: false, msg: S.dogNameInvalid };
    return { ok: true, value: value };
  }

  /* The engraving prints A–Z only, but a letter outside it is never dropped
     silently: stripping turned "Chloé" into "Chlo" and "Łatka" into "atka",
     and that is what got engraved on a piece that can't be returned.
     Accented Latin letters fold to their base letter in the field, where the
     shopper sees the change; anything with no A–Z equivalent (Cyrillic,
     Greek, digits) stays in the field and the A–Z message shows at once. */
  var NAME_FOLD = {
    "ł": "l", "Ł": "L", "ß": "ss", "ẞ": "SS", "æ": "ae", "Æ": "AE", "œ": "oe", "Œ": "OE",
    "ø": "o", "Ø": "O", "đ": "d", "Đ": "D", "ð": "d", "Ð": "D", "þ": "th", "Þ": "Th", "ı": "i",
    "’": "'", "‘": "'", "ʼ": "'", "`": "'", "‐": "-", "–": "-"
  };
  function nameFold(raw) {
    return String(raw || "")
      .replace(/[łŁßẞæÆœŒøØđĐðÐþÞı’‘ʼ`‐–]/g, function (c) { return NAME_FOLD[c]; })
      .normalize("NFD")
      .replace(/([A-Za-z])[̀-ͯ]+/g, "$1")
      .normalize("NFC");
  }
  function nameTyping(input, errorEl, e) {
    if (e && e.isComposing) return; // dead keys / IME: wait for compositionend
    var before = input.value;
    var after = nameFold(before);
    if (after !== before) {
      var caret = input.selectionStart;
      input.value = after;
      if (caret != null) {
        var pos = Math.max(0, caret + after.length - before.length);
        try { input.setSelectionRange(pos, pos); } catch (err) { /* not focusable */ }
      }
    }
    var bad = /[^A-Za-z' -]/.test(input.value);
    if (errorEl) { errorEl.textContent = bad ? S.dogNameInvalid : ""; errorEl.hidden = !bad; }
    input.style.borderColor = bad ? "var(--err, #c0392b)" : "";
  }

  var productDataCache = {};
  function getProductData(url) {
    if (!productDataCache[url]) {
      productDataCache[url] = fetch(url + ".js").then(function (r) { return r.json(); });
    }
    return productDataCache[url];
  }

  function updateCheckoutGate() {
    var checkoutBtn = document.getElementById("checkout-btn");
    var hintName = document.getElementById("checkout-hint-name");
    var hintSize = document.getElementById("checkout-hint-size");
    var pendingName = body ? body.querySelectorAll(".cart-name-input").length > 0 : false;
    var pendingSize = body ? body.querySelectorAll(".cart-size-pending").length > 0 : false;
    var pending = pendingName || pendingSize;
    if (checkoutBtn) {
      checkoutBtn.style.opacity = pending ? "0.5" : "";
      checkoutBtn.style.cursor = pending ? "not-allowed" : "";
      checkoutBtn.setAttribute("aria-disabled", String(pending));
    }
    if (hintName) hintName.hidden = !pendingName;
    if (hintSize) hintSize.hidden = !pendingSize;
    return pending;
  }

  function renderCart(cart) {
    window.__tbCart = cart;
    var countEl = document.getElementById("cart-count");
    if (countEl) countEl.textContent = cart.item_count;
    var lineEl = document.getElementById("bag-line");
    if (lineEl) {
      lineEl.textContent = (cart.item_count === 1 ? S.itemsOne : S.itemsMany || "")
        .replace("{n}", cart.item_count);
    }
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty"><div class="h">' + esc(S.cartEmptyTitle) + "</div><p>" + esc(S.cartEmptySub) + "</p></div>";
      if (foot) foot.hidden = true;
      updateCheckoutGate();
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var opts = (item.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== "Default Title"; })
          .map(function (o) { return esc(o.value); });
        Object.keys(item.properties || {}).forEach(function (k) {
          if (k.charAt(0) !== "_" && item.properties[k]) opts.push(esc(k) + ": " + esc(item.properties[k]));
        });
        var pendingName = item.properties && item.properties["_requires_name"] && !item.properties["Dog Name"];
        var pendingSize = item.properties && item.properties["_requires_size"];
        return (
          '<div class="cart-item" data-key="' + esc(item.key) + '">' +
          '<div class="pic">' +
          (item.image
            ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/, "_200x$1$2")) + '" alt="' + esc(item.product_title) + '" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">'
            : "") +
          "</div>" +
          '<div class="meta">' +
          '<div class="nm">' + esc(item.product_title) + "</div>" +
          '<div class="sub">' + opts.join(" · ") + "</div>" +
          (pendingSize
            ? '<div class="cart-size cart-size-pending" data-key="' + esc(item.key) + '" data-url="' + esc(item.url.split("?")[0]) + '" style="margin-top:8px;">' +
              '<p class="cart-size-label">' + esc(S.chooseSizeLabel) + '</p>' +
              '<div class="size-row cart-size-row" data-key="' + esc(item.key) + '"></div>' +
              '</div>'
            : "") +
          (pendingName
            ? '<div class="cart-name" style="margin-top:8px;">' +
              '<input type="text" class="cart-name-input" data-key="' + esc(item.key) + '" maxlength="14" autocomplete="off" autocapitalize="words" spellcheck="false" placeholder="' + esc(S.dogNamePlaceholder) + '" aria-label="' + esc(S.dogNamePlaceholder) + '" style="width:100%;padding:12px 14px;font-family:var(--mono);font-size:14px;letter-spacing:0.04em;color:var(--ink);background:transparent;border:1.5px solid var(--ink);border-radius:10px;outline:none;">' +
              '<p class="cart-name-error" role="alert" hidden style="margin:6px 0 0;font-family:var(--mono);font-size:11.5px;color:var(--err,#c0392b);letter-spacing:0.02em;"></p>' +
              "</div>"
            : "") +
          '<div class="qty">' +
          '<button type="button" data-qty="-1" aria-label="−">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty="1" aria-label="+">+</button>' +
          '<button type="button" class="rm" data-remove>' + esc(S.remove) + "</button>" +
          "</div>" +
          "</div>" +
          '<div class="px">' + money(item.final_line_price) + "</div>" +
          "</div>"
        );
      })
      .join("");

    body.querySelectorAll(".cart-size-row").forEach(function (row) {
      var wrap = row.closest(".cart-size-pending");
      var key = row.getAttribute("data-key");
      var url = wrap.getAttribute("data-url");
      var lineItem = (cart.items || []).find(function (it) { return it.key === key; });
      if (!lineItem) return;
      getProductData(url).then(function (product) {
        if (!document.body.contains(row)) return;
        var colorIdxs = [], sizeIdx = -1;
        (product.options || []).forEach(function (opt, i) {
          var n = String(opt.name).toLowerCase();
          if (n.indexOf("color") !== -1 || n.indexOf("colour") !== -1) colorIdxs.push(i);
          else if (n.indexOf("size") !== -1) sizeIdx = i;
        });
        if (sizeIdx === -1) return;
        var colorMatch = colorIdxs.map(function (ci) {
          return lineItem.options_with_values[ci] && lineItem.options_with_values[ci].value;
        });
        var seen = {};
        var sizes = [];
        product.variants.forEach(function (v) {
          var val = v.options[sizeIdx];
          if (val && !seen[val]) { seen[val] = true; sizes.push(val); }
        });
        row.innerHTML = sizes
          .map(function (s) { return '<button type="button" class="size-btn" data-size="' + esc(s) + '">' + esc(s) + "</button>"; })
          .join("");
        row.querySelectorAll("[data-size]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var chosen = btn.getAttribute("data-size");
            var targetVariant = product.variants.find(function (v) {
              return v.options[sizeIdx] === chosen &&
                colorIdxs.every(function (ci, k) { return v.options[ci] === colorMatch[k]; }) &&
                v.available;
            });
            if (!targetVariant) return;
            row.querySelectorAll("[data-size]").forEach(function (b) { b.disabled = true; });
            var newProps = {};
            Object.keys(lineItem.properties || {}).forEach(function (k) {
              if (k !== "_requires_size") newProps[k] = lineItem.properties[k];
            });
            fetch(ROUTES.cartChange, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: key, quantity: 0 }),
            })
              .then(function () {
                return addToCart({ items: [{ id: targetVariant.id, quantity: lineItem.quantity, properties: newProps }] });
              })
              .catch(function () { alert(S.cartError); });
          });
        });
      }).catch(function () { /* leave the row empty if the product fetch fails */ });
    });

    if (foot) {
      foot.hidden = false;
      var sub = document.getElementById("cart-subtotal");
      var tot = document.getElementById("cart-total");
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      if (tot) tot.textContent = money(cart.total_price);
    }

    updateCheckoutGate();
  }

  /* When a blur-save's /cart/change.js response comes back and renderCart()
     rebuilds #cart-body's innerHTML, any OTHER cart-name-input the shopper
     had started typing into (a different still-pending line) would be
     destroyed and recreated, dropping its in-progress value and focus. If
     the currently-focused element is a cart-name-input, snapshot its value
     and cursor position before renderCart() runs, then restore them onto
     the matching input (same data-key) in the freshly-rendered DOM. */
  function preserveFocusedCartName(cart) {
    var active = document.activeElement;
    var restore = null;
    if (active && active.classList && active.classList.contains("cart-name-input")) {
      restore = {
        key: active.getAttribute("data-key"),
        value: active.value,
        start: active.selectionStart,
        end: active.selectionEnd,
      };
    }
    renderCart(cart);
    if (restore) {
      var again = body ? body.querySelector('.cart-name-input[data-key="' + restore.key.replace(/"/g, '\\"') + '"]') : null;
      if (again) {
        again.value = restore.value;
        again.focus();
        if (typeof again.setSelectionRange === "function") {
          again.setSelectionRange(restore.start, restore.end);
        }
      }
    }
  }

  function refreshCart() {
    return fetch(ROUTES.cartGet)
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  if (body) {
    body.addEventListener("click", function (e) {
      var item = e.target.closest(".cart-item");
      if (!item) return;
      var key = item.getAttribute("data-key");
      var qtyBtn = e.target.closest("[data-qty]");
      var removeBtn = e.target.closest("[data-remove]");
      if (!qtyBtn && !removeBtn) return;

      var current = parseInt(item.querySelector(".qty span").textContent, 10) || 0;
      var next = removeBtn ? 0 : Math.max(0, current + parseInt(qtyBtn.getAttribute("data-qty"), 10));

      /* Answer the click immediately. Without this the row — its price
         included — sits there for the whole round trip, which reads as the
         removal not having worked. renderCart() below replaces the markup
         with the server's truth, and the catch puts the row back if the
         request fails. */
      if (next === 0) {
        item.style.display = "none";
      } else {
        item.style.opacity = "0.45";
        item.style.pointerEvents = "none";
      }

      fetch(ROUTES.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: next }),
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {
          item.style.display = "";
          item.style.opacity = "";
          item.style.pointerEvents = "";
          alert(S.cartError);
        });
    });
  }

  if (body) {
    var onCartNameTyping = function (e) {
      var input = e.target.closest(".cart-name-input");
      if (!input) return;
      nameTyping(input, input.parentNode.querySelector(".cart-name-error"), e);
    };
    body.addEventListener("input", onCartNameTyping);
    body.addEventListener("compositionend", onCartNameTyping);

    /* blur does not bubble — delegate on the capture phase */
    body.addEventListener("blur", function (e) {
      var input = e.target.closest(".cart-name-input");
      if (!input) return;
      var check = nameValidate(input.value);
      var errorEl = input.parentNode.querySelector(".cart-name-error");
      if (!check.ok) {
        if (errorEl) { errorEl.textContent = check.msg; errorEl.hidden = false; }
        input.style.borderColor = "var(--err, #c0392b)";
        return;
      }
      if (errorEl) errorEl.hidden = true;
      input.style.borderColor = "";
      fetch(ROUTES.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: input.getAttribute("data-key"), properties: { "Dog Name": check.value } }),
      })
        .then(function (r) { return r.json(); })
        .then(preserveFocusedCartName)
        .catch(function () { alert(S.cartError); });
    }, true);
  }

  var checkoutBtn = document.getElementById("checkout-btn");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var firstPendingSize = body ? body.querySelector(".cart-size-pending") : null;
      if (firstPendingSize) {
        e.preventDefault();
        firstPendingSize.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      var firstPending = body ? body.querySelector(".cart-name-input") : null;
      if (!firstPending) return;
      e.preventDefault();
      var errorEl = firstPending.parentNode.querySelector(".cart-name-error");
      if (errorEl) { errorEl.textContent = S.dogNameEmpty; errorEl.hidden = false; }
      firstPending.style.borderColor = "var(--err, #c0392b)";
      firstPending.focus();
    });
  }

  function addToCart(payload) {
    return fetch(ROUTES.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json().then(function (added) {
        try {
          document.dispatchEvent(new CustomEvent("tb:cart:add", { detail: added }));
        } catch (err) { /* analytics only — never block the add */ }
        return refreshCart().then(function () { setCartOpen(true); });
      });
    });
  }

  /* ── product figures: a different product + colour each page load ──
     Any figure rendered by snippets/product-figure carries one real
     candidate in its markup — crawlable, and what the page shows with JS
     off — plus the full list as JSON. Shopify caches the HTML, so the
     shuffle has to happen here rather than in Liquid. Several figures can
     sit on one page, so this handles all of them, not a single known id. */
  document.querySelectorAll("[data-pf]").forEach(function (fig) {
    var data = fig.querySelector('script[type="application/json"]');
    var img = fig.querySelector("img");
    if (!data || !img) return;
    var groups;
    try { groups = JSON.parse(data.textContent); } catch (e) { return; }
    if (!groups || !groups.length) return;
    /* product first, then one of its photos — a flat list would favour the
       product with the most variants (The Tide: 216 vs The Bone's 36) */
    var shots = groups[Math.floor(Math.random() * groups.length)];
    if (!shots || !shots.length) return;
    var pick = shots[Math.floor(Math.random() * shots.length)];
    if (!pick || pick.src === img.getAttribute("src")) return;
    img.src = pick.src;
    img.alt = pick.alt || "";
    if (pick.w) img.width = pick.w;
    if (pick.h) img.height = pick.h;
    fig.href = pick.url;
  });

  /* ── product card swatches: hover / tap repaints the card ──
     Each dot carries the photo, chip text, tint class and PDP link for its
     color (see snippets/product-card.liquid). Sticky: the card stays on
     the last hovered color so the pointer can travel to the "Add +" pill,
     which opens the PDP on that color. */
  function paintCardSwatch(sw) {
    var card = sw.closest(".pcard");
    if (!card || sw.classList.contains("on")) return;
    card.querySelectorAll(".sw.on").forEach(function (b) { b.classList.remove("on"); b.setAttribute("aria-pressed", "false"); });
    sw.classList.add("on");
    sw.setAttribute("aria-pressed", "true");

    var img = card.querySelector(".ph img");
    if (img && sw.getAttribute("data-src")) {
      img.src = sw.getAttribute("data-src");
      img.srcset = sw.getAttribute("data-srcset") || "";
    }
    var chipText = card.querySelector(".color-chip .t");
    if (chipText) chipText.textContent = sw.getAttribute("data-chip") || "";
    var chipDot = card.querySelector(".color-chip .d");
    if (chipDot) chipDot.style.background = sw.getAttribute("data-style") || "";

    card.classList.forEach(function (c) { if (c.indexOf("bg-") === 0) card.classList.remove(c); });
    if (sw.getAttribute("data-bg")) card.classList.add(sw.getAttribute("data-bg"));

    var url = sw.getAttribute("data-url");
    if (url) card.querySelectorAll("a.ph, a.nm").forEach(function (a) { a.href = url; });
  }
  document.addEventListener("mouseover", function (e) {
    var sw = e.target.closest(".pcard [data-card-swatch]");
    if (sw) paintCardSwatch(sw);
  });
  document.addEventListener("click", function (e) {
    var sw = e.target.closest(".pcard [data-card-swatch]");
    if (sw) { e.preventDefault(); paintCardSwatch(sw); }
  });

  /* ── PDP: swatches + variants + dog-name validation + AJAX add ── */
  var pdp = document.querySelector(".pdp");
  if (pdp) {
    var variantsEl = document.getElementById("product-variants");
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var priceEl = document.getElementById("pdp-price");
    var addBtn = document.getElementById("add");
    var mainImg = document.getElementById("main-img");
    var pdpImage = document.getElementById("pdp-image");
    var dogvisBadge = document.getElementById("badge-dogvis");

    /* palette comes from snippets/color-table.liquid via layout/theme.liquid —
       keys include both the canonical English name and the active locale's
       translated name, so translated variant values still resolve */
    var COLORS = window.tbColors || {};

    /* Two-tone variants ("Orange and Blue") aren't in the palette as a single
       entry — split on the joining word/symbol and resolve each half against
       the same palette, then paint a diagonal split instead of a flat hex.
       Falls back to a flat swatch (or the default tan) when the value isn't
       a recognised two-color combo. */
    function resolveSwatch(name) {
      /* collapse runs of whitespace — a variant value typed as
         "Mandarin  Orange and Ice Blue" must still hit the palette */
      var raw = String(name || "").trim().replace(/\s+/g, " ");
      var direct = COLORS[raw.toLowerCase()];
      if (direct) return { bg: direct[0], dogvis: !!direct[1] };

      var parts = raw.split(/\s+(?:and|&|\+|\/)\s+/i).map(function (p) { return p.trim(); }).filter(Boolean);
      if (parts.length === 2) {
        var a = COLORS[parts[0].toLowerCase()];
        var b = COLORS[parts[1].toLowerCase()];
        if (a && b) {
          return {
            bg: "linear-gradient(135deg, " + a[0] + " 0%, " + a[0] + " 49%, " + b[0] + " 51%, " + b[0] + " 100%)",
            dogvis: !!(a[1] || b[1]),
          };
        }
      }
      return { bg: "#E8DBB7", dogvis: false };
    }

    /* paint color swatches (option row + gallery thumbs) */
    document.querySelectorAll(".color-row .color-sw, #thumbs button").forEach(function (b) {
      var value = b.getAttribute("data-value") || b.getAttribute("data-swatch");
      var swatch = resolveSwatch(value);
      b.style.background = swatch.bg;
      if (swatch.dogvis && b.classList.contains("color-sw")) {
        b.classList.add("vis");
        b.setAttribute("data-name", value + " ♦");
      }
    });

    var groups = Array.prototype.slice.call(pdp.querySelectorAll("[data-option-index]"));
    function selection() {
      var sel = [];
      groups.forEach(function (g) {
        var on = g.querySelector(".on");
        sel[parseInt(g.getAttribute("data-option-index"), 10)] = on ? on.getAttribute("data-value") : null;
      });
      return sel;
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return sel[i] == null || opt === sel[i]; });
      });
    }

    function syncVariant() {
      var sel = selection();
      var v = findVariant(sel) || variants[0];
      if (!v) return;
      if (addBtn) {
        addBtn.setAttribute("data-variant-id", v.id);
        addBtn.disabled = !v.available;
        addBtn.style.opacity = v.available ? "" : "0.5";
        addBtn.childNodes[0].textContent = (v.available ? S.addToCart : S.soldOut) + " ";
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.image && pdpImage) pdpImage.src = v.image;

      /* per-value availability against the current selection */
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute("data-option-index"), 10);
        g.querySelectorAll("[data-value]").forEach(function (b) {
          var trial = sel.slice();
          trial[idx] = b.getAttribute("data-value");
          var match = variants.some(function (vv) {
            return vv.available && vv.options.every(function (opt, i) { return trial[i] == null || opt === trial[i]; });
          });
          b.style.opacity = match ? "" : "0.35";
        });
      });

      /* labels + gallery accent + dog-vision badge.
         A product may expose more than one color option (The Tide: bowl +
         stand); each row owns the .val label inside its own .opt block, and
         the gallery accent/badge read the whole combination. */
      var colorRows = Array.prototype.slice.call(document.querySelectorAll(".color-row"));
      if (colorRows.length) {
        var chosenColors = [];
        colorRows.forEach(function (row, i) {
          var cIdx = parseInt(row.getAttribute("data-option-index"), 10);
          var cVal = sel[cIdx];
          var swatch = resolveSwatch(cVal);
          if (cVal) chosenColors.push(cVal);
          var opt = row.closest(".opt");
          var lbl = opt ? opt.querySelector(".val") : null;
          if (lbl) lbl.textContent = cVal ? cVal + (swatch.dogvis ? " ♦" : "") : "";
          if (i !== 0) return;
          document.querySelectorAll("#thumbs button").forEach(function (b) {
            b.classList.toggle("on", b.getAttribute("data-swatch") === cVal);
          });
        });
        /* two colors paint a diagonal split (resolveSwatch already handles
           "A and B"); one or three-plus fall back to the primary swatch */
        var combo = resolveSwatch(chosenColors.length === 2 ? chosenColors.join(" and ") : chosenColors[0]);
        if (mainImg && !pdpImage) mainImg.style.background = combo.bg;
        if (dogvisBadge) {
          var anyVis = chosenColors.some(function (c) { return resolveSwatch(c).dogvis; });
          dogvisBadge.hidden = !anyVis;
        }
      }
      var sizeRow = document.getElementById("size-row");
      if (sizeRow) {
        var sizeVal = sel[parseInt(sizeRow.getAttribute("data-option-index"), 10)] || "";
        var sLbl = document.getElementById("size-lbl");
        if (sLbl) sLbl.textContent = sizeVal;

        /* Height / diameter / capacity for the chosen size, plus the matching
           card in the size-guide drawer. window.tbSizes is keyed by the raw
           variant option value and already carries a translated line, so a
           product on a size the ladder doesn't know (legacy Small/Medium/
           Large) just leaves the line blank instead of printing "undefined". */
        var sizeKey = String(sizeVal).toUpperCase();
        var spec = (window.tbSizes || {})[sizeKey];
        var specEl = document.getElementById("size-spec");
        if (specEl) specEl.textContent = spec || "";
        document.querySelectorAll(".sz-card, .sz-table tbody tr").forEach(function (c) {
          c.classList.toggle("on", (c.getAttribute("data-size") || "").toUpperCase() === sizeKey);
        });
      }
    }

    var sizeErr = document.getElementById("size-error");
    function validateSize() {
      var row = document.getElementById("size-row");
      if (!row) return true;
      return !!row.querySelector(".on");
    }

    pdp.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-option-index] [data-value]");
      if (opt) {
        var group = opt.closest("[data-option-index]");
        group.querySelectorAll(".on").forEach(function (b) { b.classList.remove("on"); });
        opt.classList.add("on");
        if (group.id === "size-row" && sizeErr && !sizeErr.hidden) sizeErr.hidden = true;
        syncVariant();
        return;
      }
      var thumb = e.target.closest("#thumbs button[data-swatch]");
      if (thumb) {
        var value = thumb.getAttribute("data-swatch");
        var row = document.querySelector(".color-row");
        if (row) {
          row.querySelectorAll(".on").forEach(function (b) { b.classList.remove("on"); });
          var target = row.querySelector('[data-value="' + value.replace(/"/g, '\\"') + '"]');
          if (target) target.classList.add("on");
        }
        syncVariant();
      }
    });

    /* Size guide dialog. <dialog> brings the focus trap, the Esc key and the
       backdrop with it; what it does not bring is a click-outside close, or
       a locked page behind it, so both are added here. Opening it scrolls
       the lineup to the size already chosen — it is wider than the dialog,
       and would otherwise always open on XS. */
    var szModal = document.getElementById("size-modal");
    if (szModal) {
      var szOpener = document.querySelector("[data-sz-open]");
      var openSizeGuide = function () {
        if (szModal.showModal) szModal.showModal();
        else szModal.setAttribute("open", "");
        document.body.style.overflow = "hidden";
        var card = szModal.querySelector(".sz-card.on");
        if (card) card.scrollIntoView({ inline: "center", block: "nearest" });
      };
      var closeSizeGuide = function () {
        if (szModal.close) szModal.close();
        else szModal.removeAttribute("open");
      };
      if (szOpener) szOpener.addEventListener("click", openSizeGuide);
      szModal.addEventListener("click", function (e) {
        /* a click landing on the dialog itself is a click on its backdrop:
           the content sits in children, so it never reaches this target */
        if (e.target === szModal || e.target.closest("[data-sz-close]")) closeSizeGuide();
      });
      szModal.addEventListener("close", function () {
        document.body.style.overflow = "";
        if (szOpener) szOpener.focus();
      });
    }

    /* quantity stepper */
    var qtyN = document.getElementById("qty-n");
    var dec = document.getElementById("dec");
    var inc = document.getElementById("inc");
    function qty() { return parseInt(qtyN ? qtyN.textContent : "1", 10) || 1; }
    if (dec) dec.addEventListener("click", function () { if (qtyN) qtyN.textContent = Math.max(1, qty() - 1); });
    if (inc) inc.addEventListener("click", function () { if (qtyN) qtyN.textContent = qty() + 1; });

    /* Dog name — same rules as the headless app:
       English letters, space/hyphen/apostrophe inside, 1–14 chars. */
    var nameInput = document.getElementById("dog-name");
    var nameErr = document.getElementById("dog-name-error");
    var nameCount = document.getElementById("dog-name-count");

    function validateName() {
      if (!nameInput) return { ok: true, value: undefined };
      return nameValidate(nameInput.value);
    }

    if (nameInput) {
      var onNameTyping = function (e) {
        nameTyping(nameInput, nameErr, e);
        if (nameCount) nameCount.textContent = nameInput.value.length + "/14";
      };
      nameInput.addEventListener("input", onNameTyping);
      nameInput.addEventListener("compositionend", onNameTyping);
    }

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        if (!validateSize()) {
          if (sizeErr) sizeErr.hidden = false;
          var sizeRow = document.getElementById("size-row");
          if (sizeRow) sizeRow.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        var check = validateName();
        if (!check.ok) {
          if (nameErr) { nameErr.textContent = check.msg; nameErr.hidden = false; }
          if (nameInput) { nameInput.style.borderColor = "var(--err, #c0392b)"; nameInput.focus(); }
          return;
        }
        var payload = { id: parseInt(addBtn.getAttribute("data-variant-id"), 10), quantity: qty() };
        if (nameInput && check.value) payload.properties = { "Dog Name": check.value };

        addBtn.disabled = true;
        addToCart({ items: [payload] })
          .catch(function (err) {
            alert((err && err.description) || S.cartError);
          })
          .finally(function () { addBtn.disabled = false; });
      });
    }

    syncVariant();
  }

  /* initial badge sync */
  refreshCart();
})();
